import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { AUTH_COOKIE_DOMAIN, APP_DEV } from "aws-exports";
import classNames from "lib/classNames";
import _ from "lodash";
import ContentLoader from "react-content-loader";
import copy from "copy-to-clipboard";
import { Toast } from "@shopify/app-bridge-react";

import { Input, Button, Page, Alert, Icon, Spinner } from "components";
import {
  faEdit,
  faCopy,
  faSave,
  faUndo,
  fabac
} from "@fortawesome/fontawesome-pro-solid";

const Affiliation = () => {
  const [settings, setSettings] = useState({});
  const [aff_code, setCode] = useState("");
  const [eventsList, setEventsList] = useState();
  const [stats, setStats] = useState({});
  const [isEditingCode, setIsEditingCode] = useState(false);
  const [isEditingPaypal, setIsEditingPaypal] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState();
  // const [paypal, setPaypal] = useState(false)
  const getAffiliationSettings = async () => {
    const {
      data,
      settings: responseSettings,
      code: aff_code
    } = await API.get("API_GATEWAY_NEW", "/aff/settings");
    console.log(data);
    console.log(responseSettings);
    setCode(aff_code);
    setSettings({...responseSettings, ...data});
  };
  const handleSubmitSettings = async (settingsTosave, codeTosave) => {
    return await API.post("API_GATEWAY_NEW", "/aff/settings", {
      body: {
        settings: settingsTosave,
        aff_code: codeTosave
      }
    });
  };

  const getEvents = async () => {
    const { stats, data } = await API.get("API_GATEWAY_NEW", "/aff/events");
    setEventsList(data);
    setStats(stats);
  };

  const handlePaypalEdit = async (paypal_email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(paypal_email)) {
      await handleSubmitSettings({ ...settings, paypal_email }, aff_code);
      setSettings({ ...settings, paypal_email });
      setIsEditingPaypal(false);
      setMessage("Settings has been saved");
    } else {
      setError("Invalid email");
    }
  };

  const handleCodeEdit = async (code) => {
    const { error: responseError } = await handleSubmitSettings(settings, code);
    if (responseError) {
      setError(responseError);
    } else {
      setCode(code);
      setIsEditingCode(false);
      setMessage("Settings has been saved");
    }
  };

  const handleLinkCopy = (link) => {
    copy(link);
    setMessage("Copied !");
  };

  useEffect(() => {
    getAffiliationSettings();
    getEvents();
  }, []);

  return (
    <Page background="none" padding={0}>
      <>
        {error && (
          <Toast
            content={error}
            duration={3000}
            error
            onDismiss={() => setError()}
          />
        )}
        {message && (
          <Toast
            content={message}
            duration={3000}
            onDismiss={() => setMessage()}
          />
        )}
        <div className={classNames("flex justify-between")}>
          <div
            className={classNames(
              " capitalize text-gray-600 text-2xl font-bold mb-6 "
            )}
          >
            Referral Program
          </div>
        </div>
        <div className={classNames("bg-white  my-4 p-4")}>
          <div className={classNames(" text-lg font-bold text-gray-600")}>
            Share Link
          </div>
          <p className={classNames("text-sm text-gray-500")}>
            {`Earn ${settings?.commission || "15"}% + Friend saves ${settings?.discount || "5"}% = Everyone is HAPPY 🥳 `}
          </p>
          <div className={classNames("flex my-2 items-center justify-center")}>
            {!aff_code ? (
              <Spinner />
            ) : !isEditingCode ? (
              <ShowCode {...{ aff_code, setIsEditingCode, handleLinkCopy }} />
            ) : (
              <EditCode {...{ aff_code, setIsEditingCode, handleCodeEdit }} />
            )}
          </div>
          <div className={classNames(" text-lg font-bold text-gray-600")}>
            Share Coupon Code
          </div>
          <p className={classNames("text-sm text-gray-500")}> Enter coupon code during MonsterUpsells installation. </p>
          <div className={classNames("flex my-2 items-center justify-center")}>
            <ShowCoupon {...{ aff_code, setIsEditingCode, handleLinkCopy }} />
          </div>
          <p className={classNames("text-sm text-gray-500")}>
            Earn{" "}
            <span className={classNames("text-blue-500 font-bold")}>
              {settings?.commission || "15"}% of all revenue for life
            </span>{" "}
            from stores registered through this link.{" "}
          </p>
          <p className={classNames("text-sm text-gray-500")}>
            Reward any paying store{" "}
            <span className={classNames("text-blue-500 font-bold")}>
              {" "}
              {settings?.discount || "5"}% off Monsterupsells for life
            </span>{" "}
            within 30 days of link click.{" "}
          </p>
        </div>
        <div className={classNames("bg-white  my-4 p-4")}>
          <div className={classNames(" text-lg font-bold text-gray-600")}>
            Payment method{" "}
          </div>
          <div className={classNames("flex my-2 items-center justify-center")}>
            {!settings?.hasOwnProperty("paypal_email") ? (
              <Spinner />
            ) : !isEditingPaypal ? (
              <ShowPaypal
                {...{ paypal: settings.paypal_email, setIsEditingPaypal }}
              />
            ) : (
              <EditPaypal
                {...{
                  paypal: settings.paypal_email,
                  setIsEditingPaypal,
                  handlePaypalEdit
                }}
              />
            )}
          </div>

          <p className={classNames("text-sm text-gray-500")}>
            {" "}
            Payouts will be sent monthly. Minimum payment $50{" "}
          </p>
        </div>

        <div
          className={classNames(
            "flex-1 capitalize text-gray-600 text-2xl font-bold mt-6"
          )}
        >
          Statics
        </div>

        <div
          className={classNames(
            "col-span-1 lg:col-span-3 grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 py-4"
          )}
        >
          <StateCard title="Clicks" value={stats.views} />
          <StateCard
            title="Active subscribers"
            value={stats.active_referrals}
          />
          <StateCard title="Accumilated Commissions" value={"$0"} />
          <StateCard title="Paid Out Commissions" value={"$0"} />
        </div>
        <div className={classNames(" pb-4 ")}>
          <div
            className={classNames("bg-white  my-4 p-4 border-b ", {
              "h-60": !eventsList || !eventsList.length
            })}
          >
            <div className={classNames(" text-lg font-bold text-gray-600")}>
              Referred Stores{" "}
            </div>
            <div
              className={classNames(
                "flex text-gray-600 text-lg font-bold border-b mt-6 "
              )}
            >
              <div className={classNames("flex-1")}>Store name</div>
              {/* <div></div> */}
              <div className={classNames("flex-1")}>Total earned</div>
            </div>
            {!eventsList ? (
              <Spinner />
            ) : (
              eventsList.map((e, index) => {
                return (
                  <div
                    className={classNames(
                      "flex text-gray-500  font-bold border-b py-2 "
                    )}
                    key={index}
                  >
                    <div className={classNames("flex-1")}>{e.referral} </div>
                    <div className={classNames("flex-1")}>${e.earnings} </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        <Alert
          type="success"
          // icon= {state.settings.sticky_cart.isActive ? 'check-circle' : 'exclamation-circle'}
          title="Want to supply your audience with unique benefits or join our agency partner ?"
          className="z-5"
        >
          <p>
            {" "}
            Please contact our team at{" "}
            <a
              href="mailto:support@monsterapps.shop"
              target="_blank"
              className={classNames("text-blue-500 font-bold")}
            >
              support@monsterapps.shop
            </a>
          </p>
        </Alert>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </>
    </Page>
  );
};

const ShowCode = ({ aff_code, setIsEditingCode, handleLinkCopy }) => {
  const link = APP_DEV
    ? `${AUTH_COOKIE_DOMAIN}/ref/${aff_code}`
    : `https://monsterupsells.com/ref/${aff_code}`;
  return (
    <>
      <Input disabled={true} disabledBgColor="bg-gray-100" value={link} />
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => handleLinkCopy(link)}
      >
        <Icon icon={faCopy} size="lg" />
      </div>
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => setIsEditingCode(true)}
      >
        <Icon icon={faEdit} size="lg" />
      </div>
    </>
  );
};
const ShowCoupon = ({ aff_code , handleLinkCopy }) => { 
  return (
    <>
      <Input disabled={true} disabledBgColor="bg-gray-100" value={aff_code} />
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => handleLinkCopy(aff_code)}
      >
        <Icon icon={faCopy} size="lg" />
      </div>
    </>
  );
};

const EditCode = ({ aff_code, setIsEditingCode, handleCodeEdit }) => {
  const [code, setCode] = useState(aff_code);

  const handleLinkEdit = () => {
    handleCodeEdit(code);
  };

  const link = APP_DEV
    ? `${AUTH_COOKIE_DOMAIN}/ref/`
    : `https://monsterupsells.com/ref/`;
  return (
    <div className={classNames("flex flex-1  items-center justify-center")}>
      <div className={classNames("text-gray-600 ml-2 mr-1")}>{link}</div>
      <Input value={code} onChange={setCode} />
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => setIsEditingCode(false)}
      >
        <Icon icon={faUndo} size="lg" />
      </div>
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={handleLinkEdit}
      >
        <Icon icon={faSave} size="lg" />
      </div>
    </div>
  );
};

const ShowPaypal = ({ paypal, setIsEditingPaypal }) => {
  return (
    <div className={classNames("flex flex-1  items-center justify-center")}>
      <Input disabled disabledBgColor="bg-gray-100" value={paypal} />
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => setIsEditingPaypal(true)}
      >
        <Icon icon={faEdit} size="lg" />
      </div>
    </div>
  );
};

const EditPaypal = ({ paypal, setIsEditingPaypal, handlePaypalEdit }) => {
  const [localPaypal, setLocalPaypal] = useState(paypal);
  return (
    <div className={classNames("flex flex-1  items-center justify-center")}>
      <Input
        disabledBgColor="bg-gray-100"
        value={localPaypal}
        onChange={setLocalPaypal}
      />
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => setIsEditingPaypal(false)}
      >
        <Icon icon={faUndo} size="lg" />
      </div>
      <div
        className={classNames(
          "h-full flex p-2 items-center justify-center text-blue-500 mx-1 cursor-pointer"
        )}
        onClick={() => handlePaypalEdit(localPaypal)}
      >
        <Icon icon={faSave} size="lg" />
      </div>
    </div>
  );
};

const StateCard = (props) => {
  const { title, value, onClick, active } = props;
  return (
    <div
      className={classNames(
        "shadow flex-1 bg-white rounded p-5 text-gray-600 cursor-pointer",
        {
          "text-blue-500 ring": active
        }
      )}
      {...{ onClick, active }}
    >
      {value === null && (
        <ContentLoader>
          <rect x="0" y="0" rx="4" ry="4" width="60%" height="30" />
          <rect x="0" y="60" rx="4" ry="4" width="30%" height="30" />
        </ContentLoader>
      )}
      <h3 className={classNames("font-bold mb-3")}>{_.startCase(title)}</h3>
      <h1 className={classNames("font-bold text-4xl")}>{value}</h1>
    </div>
  );
};

export default Affiliation;
